<template>
  <v-card>
    <v-card-title class="subheading font-weight-bold">Perfil</v-card-title>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-item>
        <v-list-item-content>ID:</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.id">{{
          details.id
        }}</v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list-item>
        <v-list-item-content>Data da Entrevista:</v-list-item-content>
        <v-list-item-content
          class="align-end pl-6"
          :title="details.data_da_entrevista"
        >
          {{ this.details.data_da_entrevista.slice(8, -14) }}/{{
            this.details.data_da_entrevista.slice(5, -17)
          }}/{{
            this.details.data_da_entrevista.slice(0, -20)
          }}</v-list-item-content
        >
      </v-list-item>
      <v-divider />

      <v-list-item>
        <v-list-item-content>Nome:</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.nome">{{
          details.nome
        }}</v-list-item-content>
      </v-list-item>
      <v-divider />

      <v-list-item>
        <v-list-item-content>Telefone:</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.telefone"
          >({{ details.telefone.slice(0, 2) }})
          {{ details.telefone.slice(2, 7) }}-{{
            details.telefone.slice(7, 11)
          }}</v-list-item-content
        >
      </v-list-item>
      <v-divider />

      <v-list-item>
        <v-list-item-content>Email:</v-list-item-content>
        <v-list-item-content class="align-end pl-6" :title="details.email">{{
          details.email
        }}</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "Information",

  props: {
    details: {
      type: Object,
      required: true,
    },
  },

  filters: {
    date: (str) => new Date(str).toLocaleString(),
  },
  methods: {
    formatDates(date) {
      let dateTurn = date.split("T")[0];
      let split = dateTurn.split("-");
      date = split;
      date = new Date(`${split[1]}/${split[2]}/${split[0]}`);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    },
  },
};
</script>

<style scoped>
.v-list {
  max-height: 75vh;
  overflow: auto;
}
</style>